import React from "react";
import { styled } from "@mui/system";
import { Box, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/EmailOutlined";

const StyledHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
  paddingRight: "10px",
}));

const StyledEmailTemplatesIcon = styled(EmailIcon)(({ theme }) => ({
  marginLeft: 16,
  fontSize: 24,
  color: theme.palette.primary.main,
  "&:hover": {
    cursor: "pointer",
  },
}));

const EmailTemplatesHeader = () => {
  return (
    <StyledHeader>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Typography
          ml={2}
          variant="h1"
          fontWeight={700}
          fontSize={26}
          sx={{ alignSelf: "flex-end" }}
          color="primary.main"
        >
          Email Templates
        </Typography>
        <StyledEmailTemplatesIcon />
      </Box>
    </StyledHeader>
  );
};

export default EmailTemplatesHeader;
